import { PERSONAL_BASE, portalPath } from './stationMode';

/** מסגרות מבחן — תואם ל-AmericanExam.frame בבקאנד */
export const EXAM_FRAMES = [
  { id: 'daf_yomi', label: 'דף היומי' },
  { id: 'shinun', label: 'דף השינון' },
  { id: 'meshannim', label: 'משננים' },
];

export const DEFAULT_EXAM_FRAME = EXAM_FRAMES[0].id;

export function examsPath(frameId = DEFAULT_EXAM_FRAME, isStation = false) {
  return `${portalPath(isStation, '/exams')}?frame=${frameId}`;
}

export function buildExamNav(isStation = false) {
  return EXAM_FRAMES.map((f) => ({
    key: `exam-${f.id}`,
    label: f.label,
    path: examsPath(f.id, isStation),
    kind: 'exam',
    frameId: f.id,
  }));
}

export function buildScoresNav(isStation = false) {
  return [
    {
      key: 'scores',
      label: 'ציונים',
      path: portalPath(isStation, '/scores'),
      kind: 'scores',
    },
  ];
}

export function buildUtilityNav(isStation = false) {
  const items = [
    {
      key: 'my-exams',
      label: 'המבחנים שלי',
      path: portalPath(isStation, '/grades'),
      kind: 'grades',
    },
    {
      key: 'calendar',
      label: 'לוח שנה',
      path: portalPath(isStation, '/calendar'),
      kind: 'calendar',
    },
    {
      key: 'phone',
      label: 'סיור במערכת הטלפונית',
      path: portalPath(isStation, '/phone'),
      kind: 'phone',
    },
  ];
  if (!isStation) {
    items.push({
      key: 'lessons',
      label: 'שיעורים',
      path: portalPath(false, '/library'),
      kind: 'library',
    });
    items.push({
      key: 'contact',
      label: 'משוב ומייל',
      path: portalPath(false, '/contact'),
      kind: 'contact',
    });
  }
  return items;
}

export function buildTopNav(isStation = false) {
  return [...buildExamNav(isStation), ...buildScoresNav(isStation), ...buildUtilityNav(isStation)];
}

/** @deprecated use buildExamNav / buildTopNav — kept for personal default */
export const EXAM_NAV = buildExamNav(false);
export const UTILITY_NAV = buildUtilityNav(false);
export const TOP_NAV = buildTopNav(false);

function stripPortalPrefix(pathname) {
  if (pathname === '/mishtameret/station' || pathname.startsWith('/mishtameret/station/')) {
    return pathname.slice('/mishtameret/station'.length) || '/';
  }
  if (pathname === PERSONAL_BASE || pathname.startsWith(`${PERSONAL_BASE}/`)) {
    return pathname.slice(PERSONAL_BASE.length) || '/';
  }
  return pathname;
}

export function resolveActiveNavKey(pathname, searchParams) {
  const rel = stripPortalPrefix(pathname);
  if (rel.startsWith('/scores')) return 'scores';
  if (rel.startsWith('/grades')) return 'my-exams';
  if (rel.startsWith('/library')) return 'lessons';
  if (rel.startsWith('/calendar')) return 'calendar';
  if (rel.startsWith('/phone')) return 'phone';
  if (rel.startsWith('/contact')) return 'contact';
  if (rel.startsWith('/exams')) {
    if (rel.includes('/take/')) return null;
    const frame = searchParams.get('frame') || DEFAULT_EXAM_FRAME;
    return `exam-${frame}`;
  }
  return null;
}
